
import React, { useEffect, useState } from "react";
import { MdOutlineFileDownload } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Aumreports from "./Aumreports";
import DisbursementSheet from "./DisbursementSheet";
import AllAumReportData from "./AllAumReportData";
import urls from "../../Utils/urls";

const ReportsDetails = () => {
    const navigate = useNavigate();
    const [reportLists, setReportLists] = useState([]);
    const [reportListValue, setReportListValue] = useState("");
    const [reportTypes, setReportTypes] = useState([]);
    const [reportTypeValue, setReportTypeValue] = useState("");
    const [reportData, setReportData] = useState([]);
    const [allReportsData, setAllReportsData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isReportAvailable, setIsReportAvailable] = useState(false);
    const [reportListError, setReportListError] = useState("");
    const [reportTypeError, setReportTypeError] = useState("");
    const [showSource, setShowSource] = useState('false');


    const access_token = localStorage.getItem('access_token');
    const handleGetReportLists = async () => {
        try {
            const res = await fetch(`${urls.API_BASEPATH}/source_list`);
            const data = await res.json();
            setReportLists(data)
        }
        catch (err) {
            console.error(err);
        }
    }

    const handleGetReportType = async () => {
        try {
            const res = await fetch(`${urls.API_BASEPATH}/report_list`);
            const data = await res.json();
            setReportTypes(data.reports)
        }
        catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        setShowSource(false)
        const report = reportTypes.find((report) => report.type === reportTypeValue);
        if (report?.fields?.length > 0) {
            setShowSource(true)
        }
    }, [reportTypeValue]);


    const fetchReports = async (e) => {
        e.preventDefault()
        if (!reportTypeValue) {
            setReportTypeError('Please select a report type before continuing.');
            return;
        }

        if (showSource) {
            if (!reportListValue) {
                setReportListError('Please select a report source before continuing.')
                return;
            }

        }
        setLoading(true);
        setIsReportAvailable(false);
        setReportListError('')
        setReportTypeError('')
        setAllReportsData([])
        setReportData(null)
        try {
            if (reportListValue === 'All') {
                const reportsResult = []
                for (const src of reportLists) {
                    if (src.key !== 'second') {
                        const res = await fetch(`${urls.API_BASEPATH}/get_report`, {
                            method: 'POST',
                            headers: {
                                'Authorization': access_token,
                            },
                            body: JSON.stringify(
                                {
                                    report_type: reportTypeValue,
                                    source: src.key
                                }
                            )
                        });
                        const data = await res.json()
                        reportsResult.push(data)
                        setIsReportAvailable(true);
                    }
                }
                setAllReportsData(reportsResult)
            } else {
                const res = await fetch(`${urls.API_BASEPATH}/get_report`, {
                    method: 'POST',
                    headers: {
                        'Authorization': access_token,
                    },
                    body: JSON.stringify(
                        {
                            report_type: reportTypeValue,
                            source: reportListValue || "default"
                        }
                    )
                });

                const data = await res.json();
                if (data.status === 0) {
                    alert(data.message);
                    navigate('/admin/login')
                    setReportData([]);
                    setIsReportAvailable(false);
                    return;
                }
                setReportData(data);
                setIsReportAvailable(true);
            }

        } catch (err) {
            alert("Error: Failed to fetch report data. This report is currently under development.");
            console.error("Error: ", err);
        }
        finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        handleGetReportLists()
        handleGetReportType()
    }, [])

    const renderReportComponent = () => {
        if (reportListValue === 'All') {
            return <AllAumReportData allReportsData={allReportsData} convertFormet={convertFormet} />
        }

        if (reportTypeValue === "aum_report") {
            return <Aumreports reportData={reportData} convertFormet={convertFormet} />
        }

        if (reportTypeValue === "disbursement_sheet") {
            return <DisbursementSheet reportData={reportData} convertFormet={convertFormet} />
        }
    }

    const convertFormet = (convertFormet) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(convertFormet ?? 0)
    }


    return (

        <div className="flex justify-center items-center  bg-gray-100 p-4 md:p-10">
            <div className="w-full  bg-white rounded-xl min-h-screen sm:min-h-[500px] shadow-lg border overflow-hidden">

                <div className="bg-red-500 text-white text-center py-3 font-bold text-lg">
                    POS
                </div>
                <form>

                    <div className="flex flex-wrap items-center justify-between gap-5 p-4 md:p-8 border-b">
                        <div className="w-full sm:w-full md:max-w-sm">
                            <label className="block text-gray-700 mb-2 font-medium">
                                Report Type
                            </label>
                            <select
                                value={reportTypeValue}
                                onChange={(e) => { setReportTypeValue(e.target.value); setReportTypeError(''); setIsReportAvailable(false) }
                                }
                                className="w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <option value=''>Select Report Type</option>
                                {reportTypes.map((report, index) => (
                                    <option value={report.type} key={index}>{report.label}</option>
                                ))}
                            </select>
                            {reportTypeError && <p className="text-red-500">{reportTypeError}</p>}
                        </div>

                        {showSource &&
                            <div className="w-full sm:w-full md:max-w-sm">
                                <label className="block text-gray-700 mb-2 font-medium">
                                    Report Source
                                </label>

                                <select
                                    value={reportListValue}
                                    onChange={(e) => { setReportListValue(e.target.value); setReportListError(''); setIsReportAvailable(false) }}
                                    required
                                    className="w-full border rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                >
                                    <option value="">Select Report Source</option>
                                    <option value="All">All sources</option>
                                    {reportLists.map((report, index) => (
                                        <option value={report.key} name={report.label} key={index}>{report.label}</option>
                                    ))}
                                </select>

                                {reportListError && <p className="text-red-500">{reportListError}</p>}
                            </div>}

                    </div>
                    <div className="p-8 flex justify-center">
                        <button className="bg-blue-600 text-white px-6 py-2 rounded-lg shadow  transition flex items-center gap-2 hover:!bg-blue-600 hover:!text-white"
                            onClick={fetchReports}>
                            {loading ? (
                                <>
                                    <svg
                                        className="animate-spin h-5 w-5 text-white"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                    >
                                        {/* Simplified path - faster rendering */}
                                        <path
                                            fill="currentColor"
                                            d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
                                            opacity="0.25"
                                        />
                                        <path
                                            fill="currentColor"
                                            d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z"
                                        />
                                    </svg>
                                    Fetching Report...
                                </>
                            ) : (<span className="flex gap-2 items-center"><MdOutlineFileDownload className="text-xl" /> Fetch Report</span>)}
                        </button>
                    </div>
                </form>
                {!isReportAvailable ? (
                    <div className="flex flex-col items-center justify-center  p-6 border-2 border-dashed border-gray-300 rounded-md bg-gray-50 text-gray-600">
                        <svg
                            className="w-10 h-10 mb-2 text-gray-400"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9.75 9.75h.008v.008H9.75V9.75zm4.5 0h.008v.008H14.25V9.75zM9.75 14.25h.008v.008H9.75V14.25zm4.5 0h.008v.008H14.25V14.25z"
                            />
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M3 3v18h18V3H3zm3 3h12v12H6V6z"
                            />
                        </svg>
                        <p className="text-lg font-medium">No data available</p>
                        <p className="text-sm text-gray-500 mt-1">Try adjusting your filters or date range.</p>
                    </div>
                ) :
                    (renderReportComponent()
                    )}
            </div>
        </div>

    );
};

export default ReportsDetails;

